module.exports = __webpack_public_path__ + "img/google.d7108a1c.svg";